export const STRIPE_PROCESSING_FEE_PERCENT = 0.029;
export const STRIPE_PROCESSING_FEE_BASE = 30; // in cents

export const MEMBERSHIP_GRACE_PERIOD_IN_DAYS = 10;
